const getOfferName = (offerId, offers) => offers.filter((offer) => offer.id === offerId)[0].name;
export default getOfferName;
